<template>
    <div class="exception-body error">
        <img src="assets/layout/images/logo-mides-white.svg" alt="mides-layout" class="logo" />

        <div class="exception-content">
            <div class="exception-title">ERROR</div>
            <div class="exception-detail">Algo salió mal.</div>
            <router-link to="/login">Ir al Inicio</router-link>
        </div>
    </div>
</template>

<script>
export default {};
</script>